export default {
  forgot_password_submit: {
    title: 'Atur ulang kata sandi',
    submit_complete: 'Berhasil dikirim',
    password_reset: 'Kata sandi telah diatur ulang',
  },
}
